import AuthService from "../login/auth.service";
import { comprobantes, dimo } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class TransferXpressService {

  async getTipoEntidades() {
    var config = {
      method: "get",
      url: dimo + "entidadesXpress/obtenerTipoEntidades",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      }
    };

    return await axios(config);
  }

  async getEntidades(tipoEntidad) {
    var data = JSON.stringify({
      tipo: tipoEntidad,
    })

    var config = {
      method: "POST",
      url: dimo + "entidadesXpress/obtenerEntidades",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data,
    };

    return await axios(config);
  }

  async confirmarTransferencia(data) {
    var config = {
      method: "post",
      url: dimo + "operaciones/realizarTransaccion",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data,
    };

    return await axios(config);
  }

  async descagarComprobante(data) {

    var _url = comprobantes + "comprobantes/v2/transferencias-xpress";

    var config = {
      method: "POST",
      url: _url,
      data: data,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }
}
export default new TransferXpressService();
